import './ZoomCursors.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var cursorStyle = _7a468({defaultClassName:'_1a4r99h2-2-0-1',variantClassNames:{isPanEnabled:{true:'_1a4r99h0-2-0-1',false:'_1a4r99h1-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var defaultCursor = '_1a4r99h1-2-0-1';
export var resizeCursor = '_1a4r99h0-2-0-1';